module.exports = __webpack_public_path__ + "crossroads.6f7c906d76010e2700c80e93ccffbf81.svg";